import { types } from "mobx-state-tree"

const RallySafeCountry = types.model('RallySafeCountry', {
    id: types.identifierNumber,
    name: types.string,
})

export default RallySafeCountry
